module.exports = __webpack_public_path__ + "static/Q1Answer4_Brown_wishmas-58e4b41015117eea96d291c82d27933d.jpg";